"use client"

import Link from "next/link"
import { Button } from "@/components/Button"

export default function BlogError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-text mb-4">
          Something went wrong
        </h1>
        <p className="text-text-secondary mb-8">
          {error.message || "Failed to load blog content"}
        </p>
        <div className="flex gap-4 justify-center">
          <Button variant="secondary" onClick={reset}>
            Try again
          </Button>
          <Button variant="primary" href="/blog">
            Back to Blog
          </Button>
        </div>
      </div>
    </div>
  )
}
